import React from "react";
import "./ProjectDetail.scss";
import img1 from "../../images/projects/img1.png";
import img2 from "../../images/projects/img2.png";
import Image from "./Image/Image";
import { Context } from "../../App";
import { useParams } from "react-router-dom";
// console.log(Context);
const ProjectDetail = () => {
  const { id } = useParams();
  return (
    <Context.Consumer>
      {(project_arr) => {
        return (
          <>
            <div className="project-detail container my-5">
              <div className="detail-header row">
                <div className="header-img col-md-6 my-5 d-flex justify-content-center align-items-center">
                  <img src={project_arr[id].banner}></img>
                </div>
                <div className="header-txt col-md-6 mt-5">
                  <p>
                    <strong>Name :</strong> {project_arr[id].name}
                  </p>
                  <p>
                    <strong>Technologies Used : </strong>
                    {project_arr[id].tech}
                  </p>
                  <p>
                    <strong>Description : </strong>
                    {project_arr[id].desc}
                  </p>
                  <p>
                    <strong>Live Link : </strong>
                    <a href={project_arr[id].link}>{project_arr[id].link}</a>
                  </p>
                </div>
              </div>
              <div className="text-center">
                <h6 class="detail-heading">Images</h6>
              </div>
              <div className="project-images my-2 row">
                {project_arr[id].img.map((im) => (
                  <Image image={im} />
                ))}
              </div>
            </div>
          </>
        );
      }}
    </Context.Consumer>
  );
};

export default ProjectDetail;
